__turbopack_context__.v({
  "iframe": "CustomComponent-module__Q4Qnja__iframe",
});
